import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getArendeNyaStangdaYear,setofUpdatedashboardArende } from 'actions'
import {isEmpty,isUndefined, isEqual} from 'lodash'
import {Grid} from '@material-ui/core'
import moment from 'moment'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class Diagram extends Component {
  state={
    DashboardAnpassadFilterOption:[],
    done: false
  }
  intervalID = null
  componentDidMount=()=>{
    const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getArendeNyaStangdaYear(userid,Afid,[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption])
        .then(() => {
          this.initiateInterval() 
          this.setState({done: true})   
      })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
    this.intervalID = setInterval(
      () => {
        if(this.state.done === true){            
          this.setState({done: false}) 
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getArendeNyaStangdaYear(userid,Afid,[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption])
        .then(() => {
          this.initiateInterval() 
          this.setState({done: true})   
      })
    }
      },
      180000
  );
   
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  if(parseInt(this.props.updatedashboardArende) === 1){
    this.props.getArendeNyaStangdaYear(userid,Afid,[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption])  /**/
        .then(() => {
          this.initiateInterval() 
          this.setState({done: true})   
      })
    this.props.setofUpdatedashboardArende()
  }   
    if(!isEqual([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],this.state.DashboardAnpassadFilterOption))
    {
      this.setState({done: false}) 
        this.props.getArendeNyaStangdaYear(userid,Afid,[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption])  /**/
        .then(() => {
          this.initiateInterval() 
          this.setState({done: true})   
      })
        this.setState({
            DashboardAnpassadFilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption] 
        }) 
    }
}
createData=()=>{
  let data = []
  if(isEmpty(this.props.ArendenNyaStangdaYear)){data= [
    { name: "JAN", value1:0, value2:0 },
    { name: "FEB", value1:0, value2:0 },
    { name: "MAR", value1:0, value2:0 },
    { name: "APR", value1:0, value2:0 },
    { name: "MAJ", value1:0, value2:0 },
    { name: "JUN", value1:0, value2:0 },
    { name: "JUL", value1:0, value2:0 },
    { name: "AUG", value1:0, value2:0 },
    { name: "SEP", value1:0, value2:0 },
    { name: "OKT", value1:0, value2:0 },
    { name: "NOV", value1:0, value2:0 },
    { name: "DEC", value1:0, value2:0 },
  ]}
  else{
    
  //
  return this.props.ArendenNyaStangdaYear.map(a => ({...a, value1: parseInt(a.value1), value2: parseInt(a.value2)}))
  }
}
DoRotete = (data,ShortStartMonthIndex)=>{
  let i = 0
  while(i < ShortStartMonthIndex){
    data.unshift(data.pop())
    i++
  }
  return data
}
formatNumber=(number)=>{
  if(number > 1000000){
    return `${(number/1000000).toFixed(0)}M`
}else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return isEmpty(number)?0:Number(number).toFixed(0)
}
}
formatNumber2=(number)=>{
  console.log(number)
  try{
    return `${isUndefined(number)?0:number.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`
  }catch(error){
    return 0
  }
  
}
render() {
  // console.log('test83373673', this.props.height)
  const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
  return (
    <div className="text-center potition-relative" style={{ color: 'white', height: 'calc(100% - 12px)', paddingBottom: 20, overflow: 'hidden' }}>
      <div className="d-flex justify-content-center row" style={{ marginTop: '12px' }}>
          <h2 className="col" style={{fontWeight:"500"}}><b><IntlMessages id="Errand"/></b></h2>
      {/*   <div style={{ marginTop: '-14px', marginRight:'10px' }}>
              <CustomMenu />
          </div>*/}
      </div>
      <div className="d-flex justify-content-center align-items-center" style={{height: 'calc(100% - 50px)'}}>
        <Grid container>
            <Grid xs={12} item style={{color: '#fff'}}>
              {
                this.state.done === false?
                <Skeleton variant="rectangular"  width="95%" height={this.props.height >= 100 ? this.props.height : 200} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                :              
            <ResponsiveContainer className="gx-barchart" width="95%" height={this.props.height >= 100 ? this.props.height : 200}>
          {/* <ResponsiveContainer className="gx-barchart" width="95%" style={{ height:isEmpty(this.props.height) ? 180 : this.props.height }} > */}
          <BarChart
            data={this.createData()}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          >
            <XAxis stroke="#ffffff66" tick={{ fill: 'white' }} dataKey="name" />
            <YAxis stroke="#ffffff66" tick={{ fill: 'white' }} type="number" />
            {/* <CartesianGrid strokeDasharray="0" stroke="#44D1C280" /> */}
            <Tooltip cursor={{ stroke: '#0E898F40', strokeWidth: 1, fill: "#0E898F40" }} 
            labelStyle={{ color: "#075A5F" }}
            itemStyle={{ color: "#075A5F" }} />
            {/* <Legend style={{color: '#fff'}} iconType="circle" /> */}
            <Legend formatter={renderColorfulLegendText} iconType="circle" />
            <Bar
              dataKey="value1"
              name={this.props.intl.formatMessage({ id: 'DashBoard.Errand.New' })}
              barSize={10} 
              radius={[30, 30, 0, 0]}
              // fill="#075a5f"
              fill="#C377E0"
              // fill="url(#linearColors6)"
              // style={{color: '#fff'}}
            />
            <Bar
              dataKey="value2"
              name={this.props.intl.formatMessage({ id: 'DashBoard.Errand.Closed' })}
              barSize={10} 
              radius={[30, 30, 0, 0]}
              fill="#44D1C2"
              // fill="#44D1C2"
              // fill="url(#linearColors6)"
              // style={{color: '#fff'}}
            />
            </BarChart>
          </ResponsiveContainer>
        }
        </Grid>
        </Grid>
      </div>
    </div>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
  const { width } = settings;
  const { Flags,updatedashboardArende} = accountsData
  const { authUser} = auth;
  const { ArendenNyaStangdaYear,DashboardAnpassadFilterOption,StartMonth} = DashBoard;
  return { width,authUser,ArendenNyaStangdaYear,DashboardAnpassadFilterOption,StartMonth,Flags,updatedashboardArende };
};
function mapDispatchToProps(dispatch) {
  return {
    getArendeNyaStangdaYear: (userid,Afid,DashboardAnpassadFilterOption) => dispatch(getArendeNyaStangdaYear(userid,Afid,DashboardAnpassadFilterOption)),
    setofUpdatedashboardArende: () => dispatch(setofUpdatedashboardArende()),
      dispatch
  }
}
export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  injectIntl
)(Diagram);
